import { render, staticRenderFns } from "./SmartPost.vue?vue&type=template&id=0840256d&"
import script from "./SmartPost.vue?vue&type=script&lang=js&"
export * from "./SmartPost.vue?vue&type=script&lang=js&"
import style0 from "./SmartPost.vue?vue&type=style&index=0&id=0840256d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports